module.exports = __webpack_public_path__ + "img/album07_14.5ba6435c.jpg";